import Btn from "../../Btn/Btn";
import { AuthWalletIcon } from "../../Icons/AuthWalletIcon";
import s from "./ConnectionErrorModal.module.scss";

interface Props {
  onBtnClick: () => void;
}

export const ConnectionErrorModal = ({ onBtnClick }: Props) => {
  return (
    <div className={s.wrapper}>
      <div className={s.img}>
        <AuthWalletIcon />
      </div>
      <div className={s.title}>
        Connection through this wallet is not available
      </div>
      <div className={s.text}>
        For authorization, please use wallets like Tonkeeper or Tonhub. Other
        wallets at the moment are designed for asset storage and are not capable
        of processing complex transactions
      </div>
      <div className={s.btn}>
        <Btn onClick={onBtnClick}>Reconnect</Btn>
      </div>
    </div>
  );
};
